var map = {
	"./fcolmeiasememoria/default-logo.png": 34930,
	"./fcolmeiasememoria/favicon.png": 55536,
	"./fcolmeiasememoria/footer-logo.png": 28855,
	"./fcolmeiasememoria/logo-1.svg": 56413,
	"./fcolmeiasememoria/logo-2.svg": 25096,
	"./fcolmeiasememoria/logo-3.svg": 80765,
	"./fcolmeiasememoria/logo-header-mobile.svg": 99976,
	"./fcolmeiasememoria/logo-header-tablet.svg": 12096,
	"./fcolmeiasememoria/logo-header.svg": 78333,
	"./fcolmeiasememoria/logo-mobile.svg": 70322,
	"./fcolmeiasememoria/logo.svg": 86099,
	"./fcolmeiasememoria/maskable-icon.png": 79679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57207;